"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IncomingPostMessageEventType = exports.CommunicationEventType = void 0;
var CommunicationEventType;
(function (CommunicationEventType) {
    CommunicationEventType["CLOSE_MOBILE_APP"] = "closeMobileApp";
    CommunicationEventType["NEW_MESSAGE"] = "newMessage";
    CommunicationEventType["UNREAD_MESSAGES_COUNTER_UPDATE"] = "unreadMessagesCounterUpdate";
    CommunicationEventType["CHANNELS_FETCHED"] = "channelsFetched";
    CommunicationEventType["CHAT_LOADED"] = "chatLoaded";
    CommunicationEventType["LOCATION_CHANGED"] = "locationChanged";
    CommunicationEventType["WINDOW_FOCUS"] = "windowFocus";
    CommunicationEventType["WINDOW_BLUR"] = "windowBlur";
})(CommunicationEventType = exports.CommunicationEventType || (exports.CommunicationEventType = {}));
var IncomingPostMessageEventType;
(function (IncomingPostMessageEventType) {
    IncomingPostMessageEventType["RELOAD_IF_ERROR"] = "reloadIfError";
    IncomingPostMessageEventType["GO_TO_CHANNELS"] = "goToChannels";
    IncomingPostMessageEventType["GO_TO_CHANNEL"] = "goToChannel";
    IncomingPostMessageEventType["RELOAD_CHANNELS"] = "reloadChannels";
    IncomingPostMessageEventType["RELOAD_CHANNEL"] = "reloadChannel";
})(IncomingPostMessageEventType = exports.IncomingPostMessageEventType || (exports.IncomingPostMessageEventType = {}));
